import { apiUrl, apiUrl2 } from '../../../settings'

export const addCourseUrl = () => {
  return apiUrl + '/course'
}

export const listCourse = () => {
  return apiUrl + '/course'
}
export const listCourseUrl = (id) => {
  return apiUrl + '/course/' + id
}
export const quickSearchCourse = () => {
  return apiUrl + '/quickSearch/courses'
}

export const quickSearchLoadMoreCourse = () => {
  return apiUrl + '/quickSearch/loadMoreCourse'
}


export const loadCourseIntakesUrl = () => {
  return apiUrl + '/api/loadCourseIntakes'
}


export const exportCourseListUrl = () => {
  return apiUrl + '/api/exportCourseList'
}

export const courseIsSearchAbleUrl = () => {
    return apiUrl + '/api/courseIsSearchAble'
}

export const courseIsFeaturedUrl = () => {
    return apiUrl + '/api/courseIsFeatured'
}

export const topCourseUpdateUrl = () => {
    return apiUrl + '/api/topCourse'
}

export const courseIntakeListUrl = () => {
    return apiUrl + '/api/courseIntakeList'
}

export const addCourseStructureUrl = () => {
    return apiUrl + '/api/addCourseStructure'
}
export const addTemplateCourseSectionUrl = () => {
  return apiUrl2 + '/addTemplateSectionCategory'
}

export const singleCourseStructureUrl = () => {
    return apiUrl + '/api/singleCourseStructure'
}

export const updateCourseStructureUrl = () => {
    return apiUrl + '/api/updateCourseStructure'
}

export const courseStructureListUrl = () => {
    return apiUrl + '/api/courseStructure'
}
export const templateCourseCategoryListUrl = () => {
  return apiUrl2 + '/templateSectionCategoryList'
}

export const deleteCourseStructureUrl = () => {
    return apiUrl + '/api/deleteCourseStructure'
}
export const deleteTemplateCourseCategoryUrl = () => {
  return apiUrl2 + '/removeTemplateCourseCategorySection'
}
export const courseCategoryUrl = () => {
  return `${apiUrl2}/courseCategories`;
};

export const courseIsPgwpUrl = () => {
    return apiUrl + '/api/courseIsPgwp'
}
